import createPersistedState from 'vuex-persistedstate'
import { default as dataLayer, namespace as dataLayerNamespace } from './modules/data-layer'

const namespaced = true
const namespace = 'pageService'

const modules = {
    [dataLayerNamespace]: dataLayer,
}

const plugins = [
    createPersistedState({
        paths: [
            `${namespace}.${dataLayerNamespace}`,
        ],
        key: namespace,
    })
]

export {namespaced, namespace, plugins, modules}
